import { call, takeLatest, all, put, select } from 'redux-saga/effects';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { storeRatings } from '../actions/ratingsActions';
import { SEND_RATINGS, FETCH_RATINGS } from '../actions/types';
import { getLodgeIdFromUrl, getUserIdFromUrl, getTrekIdFromUrl } from '../../lib/utils';
import { getCustomToast } from '../../components/ErrorMessage';

export default function* watchRatings() {
  yield all([
    takeLatest(SEND_RATINGS, sendRatings),
    takeLatest(FETCH_RATINGS, fetchRatings),
  ]);
}

/**
 * @param  {Object} ratings
 * @param  {String}  origin
 *
 * ratings has rating title as key and rating value as number
 * origin is the source where the action is fired.
 * origin could be trek(trekOverview), lodge(ldogeDetail) or profile
 */

function* sendRatings({ ratings, origin, token }) {
  try {
    const url = endpoints[origin].ratings(id[origin]());
    const { user } = yield select();

    if (user.userId) {
      yield call(api.post, url, ratings);
    } else {
      // for guest login
      yield call(api.postAsAGuest, url, { ...ratings }, token);
    }
    getCustomToast('We appreciate your reviews and ratings.', 'success');
  } catch (err) {
    console.log(err);
  }
}

function* fetchRatings({ origin }) {
  try {
    const url = endpoints[origin].ratings(id[origin]());
    const { data } = yield call(api.get, url);

    yield put(storeRatings(data, origin));
  } catch (err) {
    console.log(err);
  }
}

const id = {
  treks: getTrekIdFromUrl,
  lodge: getLodgeIdFromUrl,
  profile: getUserIdFromUrl,
  flights: () => 'f8016c413194',
};



// WEBPACK FOOTER //
// ./src/redux/sagas/ratings.js